import { render } from "./methodList.vue?vue&type=template&id=66a63d96&scoped=true"
import script from "./methodList.vue?vue&type=script&lang=js"
export * from "./methodList.vue?vue&type=script&lang=js"

import "./methodList.vue?vue&type=style&index=0&id=66a63d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a63d96"]])

export default __exports__